/*
    this is writen by the product team 
    on the 17th of july 2018
*/
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { ResourceService } from '../../../shared/services/resource.service';


@Component({
    selector: 'select-control',
    templateUrl: './select-control.component.html',
    styleUrls: ['./select-control.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectControlComponent implements OnInit {

    dropdownList = []; // list used by the component to add the inputs
    selectedItems = []; // list used by the component to get the selected 
    dropdownSettings: any = {}; // settings for the component

    @Input() dropDownListInputs: any[] = []; // used to get the inputs from the parent;

    @Input() selectedList: any[] = []; // used to get the selected data from the parent
    @Output() selectedListChange: EventEmitter<any[]> = new EventEmitter<any[]>(); // used to update the selected array in the parent

    @Output() focusedItem: EventEmitter<any[]> = new EventEmitter<any[]>();

    @Input() inline: boolean; // used if we need to display the select menu inline not dropdown

    @Input() singleSelect: boolean; // used if we need to use a single select 

    @Input() label: string; // The property name which should be rendered as label in the dropdown
    @Input() disabled: boolean; // The property name which should be rendered as disabled in the dropdown

    @Input() itemKey: string; // The property by which the object is identified.

    @Input() options: any = {}; // options used in the component 

    constructor(private resourceService: ResourceService) 
        { }
    ngOnInit() {

        this.dropdownList = this.dropDownListInputs; // make the component data = the sent data from the parent

        this.selectedItems = this.selectedList; // set intialized data 
        if (!this.options){
            this.options = {}; 
        }
        this.dropdownSettings = {
            singleSelection: this.singleSelect ? true : false,
            text: this.options.text != undefined ? this.options.text : this.resourceService.Localize('FMS', "SelectControl_Select"),
            enableCheckAll: this.options.enableCheckAll != undefined ? this.options.enableCheckAll : true,
            selectAllText: this.options.selectAllText != undefined ? this.options.selectAllText : this.resourceService.Localize('FMS', "SelectControl_SelectAll"),
            unSelectAllText: this.options.unSelectAllText != undefined ? this.options.unSelectAllText : this.resourceService.Localize('FMS', "SelectControl_DeSelectAll"),
            filterSelectAllText: this.options.filterSelectAllText != undefined ? this.options.filterSelectAllText : this.resourceService.Localize('FMS', "SelectControl_FilterSelectAllText"),
            filterUnSelectAllText: this.options.filterUnSelectAllText != undefined ? this.options.filterUnSelectAllText : this.resourceService.Localize('FMS', "SelectControl_FilterUnSelectAllText"),
            enableSearchFilter: this.options.enableSearchFilter != undefined ? this.options.enableSearchFilter : false,
            maxHeight: this.options.maxHeight != undefined? this.options.maxHeight : 200,
            badgeShowLimit: this.options.badgeShowLimit != undefined ? this.options.badgeShowLimit : this.resourceService.Localize('FMS', "SelectControl_All"),
            classes: this.inline ? 'inline-display' : '',
            limitSelection: this.options.limitSelection != undefined ? this.options.limitSelection : 0,
            disabled: this.options.disabled != undefined ? this.options.disabled : this.disabled != undefined? this.disabled:false,
            searchBy: this.label != undefined ? [this.label] : [], // search by properties in the object
            searchPlaceholderText: this.options.searchPlaceholderText != undefined ? this.options.searchPlaceholderText : this.resourceService.Localize('FMS', "SelectControl_Search"),
            groupBy: this.options.groupBy != undefined ? this.options.groupBy : '',
            searchAutofocus: this.options.searchAutofocus != undefined ? this.options.searchAutofocus : true,
            labelKey: this.label != undefined ? this.label : 'DisplayName',
            primaryKey: this.itemKey != undefined ? this.itemKey : 'Value',
            position: 'bottom'
        };

        if (this.dropdownSettings.singleSelection)
            this.dropdownSettings.classes += " single-search"

        if (this.dropdownSettings.singleSelection)
            this.dropdownSettings.classes += " single-search no-selectall"

        if (!this.dropdownSettings.enableSearchFilter)
            this.dropdownSettings.classes += " no-search";

        if (!this.dropdownSettings.enableCheckAll)
            this.dropdownSettings.classes += " no-selectall";
    }
    onItemSelect(item: any) {
        this.selectedListChange.emit(this.selectedList);
        this.focusedItem.emit(item);
    }
    OnItemDeSelect(item: any) {
        this.selectedListChange.emit(this.selectedList);
        this.focusedItem.emit(item);
    }
    onSelectAll(items: any) {
        this.selectedListChange.emit(this.selectedList);
        this.focusedItem.emit(items);
    }
    onDeSelectAll(items: any) {
        this.selectedListChange.emit(this.selectedList);
        this.focusedItem.emit(items);
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/selectControl/select-control.component.ts